<!-- 新增商品 -->
<ng-template #Modal let-data let-ref="dialogRef">
  <form #ModalForm="ngForm">
    <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
      <nb-card-header>
        {{ moTitle }}商品  
      
      </nb-card-header>
      <nb-card-body>
        <div class="row">
          <div class="col-sm-6 px-0">          


            <!-- <div class="row mx-0 col-sm-12 "  *ngIf="info.moType==3 && info.orgType==1">
              <label class="label col-sm-12 col-form-label" > 目標商店</label>
              <nb-select
                name="CopyStoreID"   
                [(ngModel)]="mealData.CopyStoreID"
                (selectedChange)="onSelectStore()"
              >
                <nb-option 
                  *ngFor="let e of info.storeList " 
                  [value]="e.value">
                  {{ e.content }}</nb-option
                >
              </nb-select>
            </div> -->


            <div class="row mx-0 col-sm-12 "  *ngIf="info.orgType==1 || info.orgType==3 || info.pdShowType==2">
              <label class="label col-sm-12 col-form-label" > 商品種類</label>
              <nb-select *ngIf="info.isChange_Group"
                name="EOSProductGroupNo"   
                [disabled]="info.moType ==4"   
                [(ngModel)]="mealData.EOSProductGroupNo"
              >
                <nb-option 
                  *ngFor="let e of info.groupList " 
                  [value]="e.value">
                  {{ e.content }}</nb-option
                >
              </nb-select>

              <nb-select *ngIf="!info.isChange_Group"
                name="EOSProductGroupNo"   
                [disabled]="info.moType ==4"   
                [(ngModel)]="mealData.EOSProductGroupNo"
              >
                <nb-option 
                  *ngFor="let e of info.groupList " 
                  [value]="e.value">
                  {{ e.content }}</nb-option
                >
              </nb-select>
            </div>
  
            <div class="row mx-0 col-sm-12"  *ngIf="info.orgType==2">
              <label class="label col-sm-12 col-form-label">所屬菜單分類</label>
              <nb-select
                name="PRDMenuProductGroupNo"
                [disabled]="info.orgType ==2 || info.moType ==4"   
                [(ngModel)]="mealData.PRDMenuProductGroupNo"
              >
                <nb-option 
                  *ngFor="let e of info.groupList " 
                  [value]="e.value">
                  {{ e.content }}</nb-option
                >
              </nb-select>
            </div>
  
            <div class="row mx-0  col-sm-12">
              <label class="label col-sm-12 col-form-label required">
                商品名稱</label
              >
              <input
                name="ProductName"
                class="col-sm-12"
                nbInput
                fullWidth
                required
                autocomplete="off" 
                [disabled]="info.orgType ==2 || info.moType ==4"   
                [(ngModel)]="mealData.ProductName"
              />
            </div>
  
          </div>           

          <div class="col-sm-6">
            <div class="row mx-0 col-lg-12">
              <label class="label col-sm-12 col-form-label">商品圖片</label>
              <div *ngIf="info.moType ==4"  class="img-box">
                <img [src]="mealData.Image" style="width:100%">
              </div>

              <ngx-dropzone *ngIf="info.moType !=4"
                class="m-0 col-lg-12"
                [multiple]="false"
                (change)="onSelect($event,mealData)"
              >
                <ngx-dropzone-label
                  *ngIf="!mealData.Image || mealData.Image == ''"
                >
                  請將圖片拖放置此，或點此開啟資料夾 !
                </ngx-dropzone-label>
              

                <ngx-dropzone-label *ngIf="mealData.Image && mealData.Image != ''"> 
                  <div style="position: relative;width:auto; display:inline-block" >
                    <ngx-dropzone-remove-badge (click)="onRemove($event,mealData);"></ngx-dropzone-remove-badge>   
                    <img [src]="mealData.Image" style="max-width: 100%; max-height: 150px;" /> 
                  </div> 
                </ngx-dropzone-label>
  
                <ng-container *ngFor="let f of mealData.files">
                  <ngx-dropzone-image-preview
                    ngProjectAs="ngx-dropzone-preview"
                    [removable]="true"
                    (removed)="onRemove($event,mealData)"
                    [file]="f"
                  >
                  </ngx-dropzone-image-preview>
                </ng-container>
              </ngx-dropzone>
            </div>
          </div>
        </div>

        
        
        <div class="row">
          <div class="row mx-0 col-lg-12">
            <label class="label col-sm-12 col-form-label">商品介紹</label>
            <textarea
              name="ProductContant"
              rows="5"
              type="text"
              nbInput
              fullWidth
              [disabled]="info.orgType ==2 || info.moType ==4"
              [(ngModel)]="mealData.ProductContant"
            >
            </textarea>
          </div>
        </div>

        

        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required">稅別</label>
            <nb-select name="TaxType" [(selected)]="mealData.TaxType" required
              [disabled]="info.orgType ==2 || info.moType ==4"   >
              <nb-option *ngFor="let tax of TaxTypeList" [value]="tax.value">{{
                tax.content
              }}</nb-option>
            </nb-select>
          </div>

          <div class="row mx-0 col-sm-6" *ngIf="mealData.TaxType == 2">
            <label class="label col-sm-12 col-form-label required">稅額</label>
            <nb-select
              name="TaxRate"
              [(selected)]="mealData.TaxRate"
              required
              disabled
            >
              <nb-option *ngFor="let tax of TaxRateList" [value]="tax.value">{{
                tax.content
              }}</nb-option>
            </nb-select>
          </div>
        </div>

        <div class="row">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required"
              >商品原價</label
            >
            <input
              name="Cash"
              type="number"
              nbInput
              fullWidth
              required
              [disabled]="info.orgType ==2 || info.moType ==4"  
              [(ngModel)]="mealData.Cash"
            />
          </div>
        </div>

        <div class="row">
          
          <!-- 販售門市設定 / -->
          <ng-container>
            <div class="row mx-0 col-sm-12  mt-2 justify-content-between">
              <label class="label col col-form-label text-nowrap">販售門市設定</label>
              <div class="w-100 mt-2">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>販售門市</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr>
                      <td style="vertical-align: middle;">
                        {{mealData.ProductStoreMapJsonData}}
                      </td>
                      <td style="min-width: 80px;">
                        <i class="fas fa-edit" (click)="SalesOutletSetting.onOpen()">管理</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>


        <div class="row">
          
          <!-- 販售門市價格設定 / -->
          <ng-container>
            <div class="row mx-0 col-sm-12  mt-2 justify-content-between">
              <label class="label col col-form-label text-nowrap">販售門市價格設定</label>
              <button nbButton class="m-0 col-12" (click)="StoreSaleCashSetting.onAddShow()">
                新增
              </button>
              <div class="w-100 mt-2">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>售價</th>
                      <th>門市</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr *ngFor="let item of mealData.ProductStoreCashMapJsonData; let index = index">
                      <td style="vertical-align: middle;">
                        <input [name]="'StoreSaleCash' + index" type="number" [(ngModel)]="item.SaleCash" class="form-control" />
                      </td>
                      <td style="vertical-align: middle;">
                        {{item.storeName}}
                      </td>
                      <td style="min-width: 80px;">
                        <i class="fas fa-edit" (click)="StoreSaleCashSetting.onOpen(item)">管理</i>
                        <i class="fas fa-times-circle" (click)="StoreSaleCashSetting.onDel(item)">刪除</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="titleHr" *ngIf="info.pdShowType==1">
          <span>{{title2}}</span>
        </div>

        <div class="row" *ngIf="info.pdShowType==1">

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required"
              >商品售價</label
            >
            <input
              name="SaleCash"
              type="number"
              nbInput
              fullWidth
              required
              [disabled]="info.moType ==4"  
              [(ngModel)]="mealData.SaleCash"
            />
          </div>

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">排序</label>
            <input
              name="Sorting"
              type="number"
              nbInput
              fullWidth
              [disabled]="info.moType ==4"  
              [(ngModel)]="mealData.Sorting"
            />
          </div>
        </div>


      </nb-card-body>
      <nb-card-footer>
        
        <button *ngIf="info.moType != 4" nbButton (click)="onSave()" [disabled]="ModalForm.invalid">
          儲存
        </button>
        
        <button nbButton (click)="ref.close()">關閉</button>
      </nb-card-footer>
    </nb-card>
  </form>
</ng-template>

<!-- 設定供應時間 -->
<ng-template #DayModal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>設定供應時間 </nb-card-header>
    <nb-card-body>
      <div>
        <nb-checkbox [(ngModel)]="mealData.supplyTimeMonday"
          >星期一</nb-checkbox
        >
        <nb-checkbox [(ngModel)]="mealData.supplyTimeTuesday"
          >星期二</nb-checkbox
        >
        <nb-checkbox [(ngModel)]="mealData.supplyTimeWednesday"
          >星期三</nb-checkbox
        >
        <nb-checkbox [(ngModel)]="mealData.supplyTimeThursday"
          >星期四</nb-checkbox
        >
        <nb-checkbox [(ngModel)]="mealData.supplyTimeFriday"
          >星期五</nb-checkbox
        >
        <nb-checkbox [(ngModel)]="mealData.supplyTimeSaturday"
          >星期六</nb-checkbox
        >
        <nb-checkbox [(ngModel)]="mealData.supplyTimeSunday"
          >星期日</nb-checkbox
        >
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="showSupplyTime()">確定</button>
    </nb-card-footer>
  </nb-card>
</ng-template>



<!--  彈窗 選擇已存在的附加品項-->
<app-select-attachgroup  #SelectAttGMO_Tmp
   *ngIf="SelectAttGM.isShow"
    [info]="SelectAttGM.info"
    [orgData]="SelectAttGM.data"
    (emitList)="SelectAttGM.onSave($event)" 
    (emitClose)="SelectAttGM.onClose($event)" >
</app-select-attachgroup>


<!-- 彈窗 編輯附加品項群組-->
<app-edit-EOS-attachgroup  #EditEOSAttachGMO_Tmp
  *ngIf="EditEOSAttachGMO.isShow"
  [info]="EditEOSAttachGMO.info"
  [orgData]="EditEOSAttachGMO.data"
  (emitList)="EditEOSAttachGMO.onSave($event)" 
  (emitClose)="EditEOSAttachGMO.onClose($event)" >
</app-edit-EOS-attachgroup>

  <!-- 彈窗 選擇附加品項模組-->
<app-select-attachmoudle  #SelectAttMMO_Tmp
  *ngIf="SelectAttMMO.isShow"
  [info]="SelectAttMMO.info"
  [orgData]="SelectAttMMO.data"
  (emitList)="SelectAttMMO.onSave($event)" 
  (emitClose)="SelectAttMMO.onClose($event)" >
</app-select-attachmoudle>

<!-- 彈窗 販售門市-->
<app-select-salesOutlet #SalesOutletSetting_Tmp *ngIf="SalesOutletSetting.isShow" 
  [orgData]="SalesOutletSetting.data"
  (emitList)="SalesOutletSetting.onSave($event)" (emitClose)="SalesOutletSetting.onClose($event)">
</app-select-salesOutlet>

<!-- 彈窗 販售門市金額-->
<app-select-storeSaleCash #StoreSaleCashSetting_Tmp *ngIf="StoreSaleCashSetting.isShow" 
  [orgData]="StoreSaleCashSetting.data" [cash]="StoreSaleCashSetting.cash"
  (emitList)="StoreSaleCashSetting.onSave($event)" (emitClose)="StoreSaleCashSetting.onClose($event)">
</app-select-storeSaleCash>